import React from 'react';
import { useTranslation } from 'react-i18next';

const LANGUAGES = [
  { code: 'es', label: 'ES' },
  { code: 'en', label: 'EN' },
  { code: 'fr', label: 'FR' },
];

function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const handleChange = (code) => {
    i18n.changeLanguage(code);
    localStorage.setItem('omniflow_language', code);
  };

  return (
    <div className="flex items-center gap-1 bg-surfaceAlt border border-edge rounded-lg p-1">
      {LANGUAGES.map((lang) => (
        <button
          key={lang.code}
          onClick={() => handleChange(lang.code)}
          className={`px-2.5 py-1 rounded-md text-xs font-semibold cursor-pointer ${
            i18n.language === lang.code ? 'bg-accent text-panel' : 'text-muted'
          }`}
        >
          {lang.label}
        </button>
      ))}
    </div>
  );
}

export default LanguageSwitcher;